import { withTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { darken } from 'polished'
import React from 'react'

import { Alert, Button, AppBar as MuiAppBar, IconButton as MuiIconButton, Stack, Toolbar } from '@mui/material'

import { Menu as MenuIcon } from '@mui/icons-material'

import NavbarLanguagesDropdown from './NavbarLanguagesDropdown'
import NavbarUserDropdown from './NavbarUserDropdown'
import useDeployInfo from '../../hooks/useDeployInfo'
import { UserMessageSnackbar } from './UserMessageSnackbar'
import { GlobalSearch } from './GlobalSearch'

const AppBar = styled(MuiAppBar)`
    background: ${(props) => props.theme.header.background};
    color: ${(props) => props.theme.header.color};
`

const IconButton = styled(MuiIconButton)`
    svg {
        width: 22px;
        height: 22px;
    }
`

const Search = styled.div`
    border-radius: 2px;
    background-color: ${(props) => props.theme.header.background};
    display: none;
    position: relative;
    width: 500px;
    max-width: 100%;
    display: block;

    &:hover {
        background-color: ${(props) => darken(0.05, props.theme.header.background)};
    }
`

const Navbar = ({ onDrawerToggle }: { onDrawerToggle: React.MouseEventHandler }) => {
    const { hasUpdateAvailable } = useDeployInfo()

    return (
        <AppBar position='sticky' elevation={0}>
            <UserMessageSnackbar />
            {hasUpdateAvailable && (
                <Alert
                    action={
                        <Button color='inherit' onClick={() => window.location.reload()}>
                            Ladda om
                        </Button>
                    }
                    severity='warning'
                    color='warning'
                    variant='filled'
                    sx={{ borderRadius: 0 }}
                >
                    En uppdatering finns tillgänglig. Ladda om sidan för att ta del av den senaste versionen och undvika
                    eventuella problem.
                </Alert>
            )}
            <Toolbar>
                <IconButton
                    color='inherit'
                    onClick={onDrawerToggle}
                    size='large'
                    sx={{ display: { xs: 'block', md: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>
                <Search>
                    <GlobalSearch />
                </Search>

                <div style={{ flexGrow: 1 }} />
                <Stack direction='row'>
                    <NavbarLanguagesDropdown />

                    <NavbarUserDropdown />
                </Stack>
            </Toolbar>
        </AppBar>
    )
}

export default withTheme(Navbar)
